/**
 * Palveluverkosto
 */

(function($) {

  /**
   * Load ajax related
   */
  var isl_load_ajax_related_palveluverkosto = function(url, is_pagination) {

    // related
    var related_container = document.querySelector('.js-network-articles');
    var related_items = document.querySelector('.js-network-articles-items');

    var more_container = document.querySelector('.js-network-aricles-more-container');
    var more_button = document.querySelector('.js-network-aricles-more-button');

    // get related content via ajax
    related_container.classList.remove('is-hidden');
    related_container.classList.add('is-loading');

    // clear existing if is not pagination
    if (!is_pagination) {
      related_items.innerHTML = '';
    }

    $.ajax({
      url: url,
      success: function(data, textStatus, jqXHR) {
        related_container.classList.remove('is-loading');
        data = JSON.parse(data);

        // clear existing again if is not pagination (kind of fixes some async issues)
        if (!is_pagination) {
          related_items.innerHTML = '';
        }

        if (related_items && data.items.length) {

          for (var i = 0; i < data.items.length; i++) {
            related_items.innerHTML += data.items[i];
          }

        } else {
          related_container.classList.add('is-hidden');
        }

        if (more_container && more_button) {
          if (data.load_more_url) {
            more_button.setAttribute('href', data.load_more_url);
            more_container.classList.remove('is-hidden');
          } else {
            more_container.classList.add('is-hidden');
          }

        }

      },
      error: function(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR);
        related_container.classList.add('is-hidden');
      }
    }); // end ajax

  };

  /**
   * Filter items
   */
  var isl_filter_palveluverkosto = function() {

    // get active filters
    var active_filters = [];
    var s_network_filters = document.querySelectorAll('.js-s-network-filter');
    for (var i = 0; i < s_network_filters.length; ++i) {
      if (s_network_filters[i].classList.contains('is-active')) {
        // add separator characters to avoid indexof check granting partial matches like "liikenne" and "tietoliikenne"
        active_filters.push('|' + s_network_filters[i].getAttribute('data-value') + '|');
      }
    }

    // get items
    var items = [];
    var s_network_item = document.querySelectorAll('.js-s-network-item');
    for (var i = 0; i < s_network_item.length; ++i) {
      items.push({
        ref: s_network_item[i],
        industries: s_network_item[i].getAttribute('data-industry')
      })
    }

    // reset button
    var reset = document.querySelector('.js-s-network-reset');

    // related
    var related_container = document.querySelector('.js-network-articles');
    var related_items = document.querySelector('.js-network-articles-items');

    if (active_filters.length) {

      // filters are active
      for (var i = 0; i < items.length; i++) {

        var item_has_any_active_industry = false;

        for (var j = 0; j < active_filters.length; j++) {
          if (items[i].industries.indexOf(active_filters[j]) >= 0) {
            item_has_any_active_industry = true;
          }
        }

        if (item_has_any_active_industry) {
          items[i].ref.classList.remove('is-hidden');
        } else {
          items[i].ref.classList.add('is-hidden');
        }

      }

      if (reset) {
        reset.classList.add('is-visible');
      }

      if (related_container) {
        isl_load_ajax_related_palveluverkosto('/wp-content/plugins/isannointiliitto/inc/endpoints/internal-palveluverkosto-related-posts.php?terms=' + active_filters.join('|'), false);
      }

    } else {

      // no filters active
      for (var i = 0; i < items.length; i++) {
        items[i].ref.classList.remove('is-hidden');
      }

      if (reset) {
        reset.classList.remove('is-visible');
      }

      if (related_container) {
        related_container.classList.add('is-hidden');
      }

    }

    // console.log('items', items);
    // console.log('active_filters', active_filters);

  };

  /**
   * Flipping card
   */
  var s_network_flippers = document.querySelectorAll('.js-s-network-flipper');
  if (s_network_flippers.length) {
    for (var i = 0; i < s_network_flippers.length; ++i) {
      s_network_flippers[i].addEventListener('click', function(e) {
        e.currentTarget.classList.toggle('is-flipped');
      });
    }
  }

  /**
   * Service network filter
   */
  var s_network_filters = document.querySelectorAll('.js-s-network-filter');
  if (s_network_filters.length) {
    for (var i = 0; i < s_network_filters.length; ++i) {
      s_network_filters[i].addEventListener('click', function(e) {
        e.currentTarget.classList.toggle('is-active');
        isl_filter_palveluverkosto();
      });
    }
  }

  /**
   * Service network reset
   */
  var s_network_reset = document.querySelector('.js-s-network-reset');
  if (s_network_reset) {
    s_network_reset.addEventListener('click', function(e) {

      var s_network_filters = document.querySelectorAll('.js-s-network-filter');
      for (var i = 0; i < s_network_filters.length; ++i) {
        s_network_filters[i].classList.remove('is-active');
      }
      isl_filter_palveluverkosto();

    });
  }

  /**
   * Ajax pagination
   */
  var s_network_ajax_pagination = document.querySelector('.js-network-aricles-more-button');
  if (s_network_ajax_pagination) {
    s_network_ajax_pagination.addEventListener('click', function(e) {
      e.preventDefault();
      isl_load_ajax_related_palveluverkosto(e.currentTarget.getAttribute('href'), true);
    });
  }

})(jQuery);
